var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShown)?_c('div',{staticClass:"olb-notice"},[_c('div',{staticClass:"olb-notice-content"},[_vm._t("default")],2),_c('div',{staticClass:"olb-notice-close",on:{"click":_vm.close}},[_c('olb-icon',{attrs:{"name":"x-close"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }